import { createContext } from "react";

const authContext = createContext({
 
  userEmail: "" ,
  setUserEmail: () => {}
  
});

export default authContext;